/* eslint-disable max-lines */
/* eslint-disable lines-between-class-members */
/* eslint-disable dot-notation */
/* eslint-disable camelcase */
/* eslint-disable no-tabs */
/* eslint-disable max-len */
import React from "react";
// eslint-disable-next-line no-unused-vars
import NVD3Chart from "react-nvd3";
import d3 from "d3";
import axios from "axios";
import { monitotAPI } from "../../config/api";
import { deepCopy, floatToPercent } from "mazey";
import {
  Modal, Select, Button, Form, Input,
} from "antd";
import Login from "../../components/login";
import { zhName } from "../../config/page-settings";
const { Option } = Select;
const { format } = require("date-fns");
const formConfsDefault = {
  topic_id: 0,
  topic: "",
  project_name: "",
  project_description: "",
  owner: "",
  department: "",
  contact: "",
  ossIsPublic: false,
};

class DashboardV2 extends React.Component {
  constructor (props) {
    super(props);

    const formatDate = (d) => {
      // console.log(d);
      d = new Date(d + 1000 * 60 * 60 * 9);
      return format(d, "MM-dd");
    };

    this.donutChartOptions = {
      donut: true,
      showLegend: false,
      growOnHover: false,
      arcsRadius: [
        { inner: 0.65, outer: 0.93 },
        { inner: 0.6, outer: 1 },
      ],
      margin: {
        left: 10, right: 10, top: 10, bottom: 10,
      },
      donutRatio: 0.5,
      valueFormat: d3.format(",.0f"),
    };

    this.areaChartOptions = {
      pointSize: 0.5,
      useInteractiveGuideline: true,
      durection: 300,
      showControls: false,
      controlLabels: {
        stacked: "Stacked",
      },
      // interpolate: 'cardinal',
      yAxis: {
        tickFormat: d3.format(",.0f"),
      },
      xAxis: {
        tickFormat: formatDate,
      },
    };

    this.queryPerfStatistics = this.queryPerfStatistics.bind(this);
    this.getTopics = this.getTopics.bind(this);
    this.topicSelect = this.topicSelect.bind(this);
    this.handlePerfStatistics = this.handlePerfStatistics.bind(this);
    this.changeFormConfs = this.changeFormConfs.bind(this);
    this.submitFormConfs = this.submitFormConfs.bind(this);
    this.cancelSubmitFormConfs = this.cancelSubmitFormConfs.bind(this);
    this.showFormConfs = this.showFormConfs.bind(this);
    this.getURLTopic = this.getURLTopic.bind(this);
    this.init = this.init.bind(this);
    this.state = {
      // 顶部摘要
      abstract: {
        report_count: {
          value: 0,
          better: true,
          per: "0%",
        },
        response_time_avg: {
          value: 0,
          better: true,
          per: "0%",
        },
        white_time_avg: {
          value: 0,
          better: true,
          per: "0%",
        },
        onload_time_avg: {
          value: 0,
          better: true,
          per: "0%",
        },
      },
      // DNS 查询时间
      dns_time_avg: {
        line: [
          {
            key: "DNS 查询时间（单位：ms）",
            color: "#00ACAC",
            values: [],
          },
        ],
        pie: [
          {
            label: "DNS 查询时间", value: 0, color: "#00ACAC", per: "0%",
          },
          {
            label: "其他时间", value: 0, color: "#348fe2", per: "0%",
          },
        ],
      },
      // 服务器连接时间  tcp_time
      tcp_time_avg: {
        line: [
          {
            key: "服务器连接时间（单位：ms）",
            color: "#00ACAC",
            values: [],
          },
        ],
        pie: [
          {
            label: "服务器连接时间", value: 0, color: "#00ACAC", per: "0%",
          },
          {
            label: "其他时间", value: 0, color: "#348fe2", per: "0%",
          },
        ],
      },
      // 服务器响应时间  response_time
      response_time_avg: {
        line: [
          {
            key: "服务器响应时间（单位：ms）",
            color: "#00ACAC",
            values: [],
          },
        ],
        pie: [
          {
            label: "服务器响应时间", value: 0, color: "#00ACAC", per: "0%",
          },
          {
            label: "其他时间", value: 0, color: "#348fe2", per: "0%",
          },
        ],
      },
      // ⽩屏时间
      white_time_avg: {
        line: [
          {
            key: "白屏时间（单位：ms）",
            color: "#00ACAC",
            values: [],
          },
        ],
        pie: [
          {
            label: "白屏时间", value: 0, color: "#00ACAC", per: "0%",
          },
          {
            label: "其他时间", value: 0, color: "#348fe2", per: "0%",
          },
        ],
      },
      // DomReady 总时间  domready_time
      domready_time_avg: {
        line: [
          {
            key: "DomReady 总时间（单位：ms）",
            color: "#00ACAC",
            values: [],
          },
        ],
        pie: [
          {
            label: "DomReady 总时间", value: 0, color: "#00ACAC", per: "0%",
          },
          {
            label: "其他时间", value: 0, color: "#348fe2", per: "0%",
          },
        ],
      },
      // 页面加载时间  onload_time
      onload_time_avg: {
        line: [
          {
            key: "页面加载时间（单位：ms）",
            color: "#00ACAC",
            values: [],
          },
        ],
        pie: [
          {
            label: "页面加载时间", value: 0, color: "#00ACAC", per: "0%",
          },
          {
            label: "其他时间", value: 0, color: "#348fe2", per: "0%",
          },
        ],
      },
      topics: [],
      selectTopic: "",
      defaultTopic: this.getURLTopic(),
      formConfs: deepCopy(formConfsDefault),
      formConfsShow: false,
    };
  }
  // init
  componentDidMount () {
    // topics
  }

  init () {
    this.getTopics().then((topics) => {
      if (!topics.length) return;
      let selectTopic = topics[0]["topic"];
      if (topics.some(({ topic }) => topic === this.state.defaultTopic)) {
        selectTopic = this.state.defaultTopic;
        // console.log('选中了', selectTopic);
      }
      this.setState({ selectTopic }, () => {
        this.handlePerfStatistics();
      });
    });
  }

  genData ({ key, perfDays }) {
    // 历史数据
    const values = perfDays.reduce((sum, v, i) => {
      sum.push({ x: new Date(v["report_day"]).getTime(), y: v[key] });
      return sum;
    }, []);
    this.state[key]["line"][0].values = values;
    // console.log(key, this.state[key])
    // 百分比
    const todayData = perfDays[perfDays.length - 1];
    const onload_time_avg = todayData["onload_time_avg"];
    const nowTime = todayData[key];
    const remainTime = onload_time_avg - nowTime;
    this.state[key]["pie"][0].value = nowTime;
    this.state[key]["pie"][0].per = floatToPercent(nowTime / onload_time_avg);
    this.state[key]["pie"][1].value = remainTime;
    this.state[key]["pie"][1].per = floatToPercent(remainTime / onload_time_avg);
    // console.log('onload_time_avg', onload_time_avg)
    // console.log('nowTime', nowTime)
    // console.log('remainTime', remainTime)
    // console.log('', )
    this.setState({
      [key]: deepCopy(this.state[key]),
    });
  }

  genAbstract ({ key, perfDays }) {
    const todayData = perfDays[perfDays.length - 1];
    const todayKey = todayData[key];
    const yesData = perfDays[perfDays.length - 2];
    const yesKey = yesData[key];
    this.state.abstract[key].value = todayKey;
    this.state.abstract[key].better = todayKey - yesKey >= 0;
    this.state.abstract[key].per = this.state.abstract[key].better
      ? floatToPercent((todayKey - yesKey) / yesKey)
      : floatToPercent((yesKey - todayKey) / yesKey);
    this.setState({
      abstract: deepCopy(this.state["abstract"]),
    });
  }

  queryPerfStatistics ({ selectTopic } = {}) {
    return axios.get(`${monitotAPI.perfDay}?limit=30&topic=${selectTopic}`).then((res) => {
      // console.log('res', res);
      return res.data.data.perfDays;
    });
  }

  getTopics () {
    return axios
      .get(`${monitotAPI.topics}`, {
        params: { userName: zhName },
      })
      .then((res) => {
        // console.log('res', res);
        return res.data.data.topics;
      })
      .then((topics) => {
        // console.log('topics', topics);
        this.setState({ topics });
        return topics;
      });
  }

  topicSelect (selectTopic) {
    // console.log('topicSelect value', selectTopic);
    this.setState({ selectTopic }, () => {
      this.handlePerfStatistics();
    });
    // this.queryPerfStatistics({ selectTopic })
  }

  handlePerfStatistics () {
    const selectTopic = this.state.selectTopic;
    this.queryPerfStatistics({ selectTopic }).then((perfDays) => {
      // console.log('perfDays', perfDays);
      perfDays = perfDays.sort(({ report_day: a }, { report_day: b }) => new Date(a).getTime() - new Date(b).getTime());
      // console.log('perfDays sort', perfDays);
      if (perfDays.length < 2) {
        Modal.info({
          title: "提醒",
          content: (
            <div>
              <p>至少需要两日数据，你现在只有 {perfDays.length} 日。</p>
            </div>
          ),
          onOk () {},
        });
        return;
      }
      // 摘要
      this.genAbstract({ key: "report_count", perfDays });
      this.genAbstract({ key: "response_time_avg", perfDays });
      this.genAbstract({ key: "white_time_avg", perfDays });
      this.genAbstract({ key: "onload_time_avg", perfDays });
      // 图表
      this.genData({ key: "dns_time_avg", perfDays });
      this.genData({ key: "tcp_time_avg", perfDays });
      this.genData({ key: "response_time_avg", perfDays });
      this.genData({ key: "white_time_avg", perfDays });
      this.genData({ key: "domready_time_avg", perfDays });
      this.genData({ key: "onload_time_avg", perfDays });
    });
  }

  // 显示项目配置
  showFormConfs () {
    this.setState({ formConfsShow: true });
  }

  // 修改项目配置
  changeFormConfs (attr, e) {
    // let value;
    const value = e.target.value;
    // console.log(arguments, value, { [attr]: value })
    const nFormConfs = Object.assign(this.state.formConfs, { [attr]: value });
    this.setState({ formConfs: nFormConfs });
  }

  // 提交项目配置
  submitFormConfs () {
    // console.log('submit')
    // console.log('formConfs: ', this.state.formConfs)
    const c = this.state.formConfs;
    axios
      .post(`${monitotAPI.addTopic}`, {
        topic: c.topic,
        project_name: c.project_name,
        project_description: c.project_description,
        owner: c.owner,
        department: c.department,
        contact: c.contact,
        userName: zhName,
      })
      .then(({ data: res }) => {
        const { ret } = res;
        if (ret === 0) {
          this.getTopics();
          this.cancelSubmitFormConfs();
        }
      });
  }

  // 取消修改项目配置
  cancelSubmitFormConfs () {
    this.setState({ formConfsShow: false, formConfs: deepCopy(formConfsDefault) });
  }

  // 取得链接上的 topic
  getURLTopic () {
    const hash = location.hash;
    let topic = "";
    const hashs = hash.split("/");
    if (hashs.length === 4) {
      topic = hashs[3];
    }
    return topic;
  }

  render () {
    return (
      <Login init={this.init}>
        <ol className="breadcrumb pull-right">
          <li className="breadcrumb-item">首页</li>
          <li className="breadcrumb-item">监控</li>
          <li className="breadcrumb-item active">前端性能</li>
        </ol>
        <h1 className="page-header">
          前端性能 <small></small>
          <Select
            defaultValue={this.state.defaultTopic}
            value={this.state.selectTopic}
            style={{ width: 200 }}
            onChange={this.topicSelect}
          >
            {this.state.topics.map(({ topic, project_name, topic_id }) => {
              return <Option value={topic} key={`o-${topic_id}`}>{`${project_name}（topic：${topic}）`}</Option>;
            })}
          </Select>
          <Button className="m-l-5" onClick={this.showFormConfs} htmlType="button">
            新增
          </Button>
          <Button className="m-l-5" onClick={() => window.open("https://blog.mazey.net/feperf")} type="link">
            接入文档
          </Button>
        </h1>
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="widget widget-stats bg-gradient-teal">
              <div className="stats-icon stats-icon-lg">
                <i className="fa fa-globe fa-fw"></i>
              </div>
              <div className="stats-content">
                <div className="stats-title">今日抽样数据（单位：次）</div>
                <div className="stats-number">{this.state.abstract["report_count"].value}</div>
                <div className="stats-progress progress">
                  <div className="progress-bar" style={{ width: this.state.abstract["report_count"].per }}></div>
                </div>
                <div className="stats-desc">
                  相对昨日 {this.state.abstract["report_count"].better ? "增加" : "减少"} (
                  {this.state.abstract["report_count"].per})
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="widget widget-stats bg-gradient-blue">
              <div className="stats-icon stats-icon-lg">
                <i className="fa fa-hourglass fa-fw"></i>
              </div>
              <div className="stats-content">
                <div className="stats-title">今日服务器响应时间（单位：ms）</div>
                <div className="stats-number">{this.state.abstract["response_time_avg"].value}</div>
                <div className="stats-progress progress">
                  <div className="progress-bar" style={{ width: this.state.abstract["response_time_avg"].per }}></div>
                </div>
                <div className="stats-desc">
                  相对昨日 {this.state.abstract["response_time_avg"].better ? "增加" : "减少"} (
                  {this.state.abstract["response_time_avg"].per})
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="widget widget-stats bg-gradient-purple">
              <div className="stats-icon stats-icon-lg">
                <i className="fa fa-comment-alt fa-fw"></i>
              </div>
              <div className="stats-content">
                <div className="stats-title">今日⽩屏时间（单位：ms）</div>
                <div className="stats-number">{this.state.abstract["white_time_avg"].value}</div>
                <div className="stats-progress progress">
                  <div className="progress-bar" style={{ width: this.state.abstract["white_time_avg"].per }}></div>
                </div>
                <div className="stats-desc">
                  相对昨日 {this.state.abstract["white_time_avg"].better ? "增加" : "减少"} (
                  {this.state.abstract["white_time_avg"].per})
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="widget widget-stats bg-gradient-black">
              <div className="stats-icon stats-icon-lg">
                <i className="fa fa-archive fa-fw"></i>
              </div>
              <div className="stats-content">
                <div className="stats-title">今日页面加载时间（单位：ms）</div>
                <div className="stats-number">{this.state.abstract["onload_time_avg"].value}</div>
                <div className="stats-progress progress">
                  <div className="progress-bar" style={{ width: this.state.abstract["onload_time_avg"].per }}></div>
                </div>
                <div className="stats-desc">
                  相对昨日 {this.state.abstract["onload_time_avg"].better ? "增加" : "减少"} (
                  {this.state.abstract["onload_time_avg"].per})
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* 页面加载时间 */}
          <div className="col-lg-12">
            <div className="widget-chart with-sidebar inverse-mode">
              <div className="widget-chart-content bg-black" style={{ marginRight: "0" }}>
                <h4 className="chart-title">
                  页面加载时间
                  <small></small>
                </h4>
                <div className="widget-chart-full-width nvd3-inverse-mode">
                  <NVD3Chart
                    type="stackedAreaChart"
                    datum={this.state["onload_time_avg"]["line"]}
                    height={260}
                    options={this.areaChartOptions}
                  />
                </div>
              </div>
              {/* <div className="widget-chart-sidebar bg-black-darker">
                <div className="chart-number">
                  百分比
                  <small></small>
                </div>
                <div className="nvd3-inverse-mode" style={{ height: '180px' }}>
                  <NVD3Chart type="pieChart" datum={this.state['onload_time_avg']['pie']} height={180} options={this.donutChartOptions} x="label" y="value" />
                </div>
                <ul className="chart-legend f-s-11">
                  <li><i className="fa fa-circle fa-fw text-success f-s-9 m-r-5 t-minus-1"></i> {this.state['onload_time_avg']['pie'][0]['per']} <span>页面加载时间</span></li>
                  <li><i className="fa fa-circle fa-fw text-primary f-s-9 m-r-5 t-minus-1"></i> {this.state['onload_time_avg']['pie'][1]['per']} <span>其他时间</span></li>
                </ul>
              </div> */}
            </div>
          </div>
          {/* DNS 查询时间 */}
          <div className="col-lg-12">
            <div className="widget-chart with-sidebar inverse-mode">
              <div className="widget-chart-content bg-black">
                <h4 className="chart-title">
                  DNS 查询时间
                  <small></small>
                </h4>
                <div className="widget-chart-full-width nvd3-inverse-mode">
                  <NVD3Chart
                    type="stackedAreaChart"
                    datum={this.state["dns_time_avg"]["line"]}
                    height={260}
                    options={this.areaChartOptions}
                  />
                </div>
              </div>
              <div className="widget-chart-sidebar bg-black-darker">
                <div className="chart-number">
                  百分比
                  <small></small>
                </div>
                <div className="nvd3-inverse-mode" style={{ height: "180px" }}>
                  <NVD3Chart
                    type="pieChart"
                    datum={this.state["dns_time_avg"]["pie"]}
                    height={180}
                    options={this.donutChartOptions}
                    x="label"
                    y="value"
                  />
                </div>
                <ul className="chart-legend f-s-11">
                  <li>
                    <i className="fa fa-circle fa-fw text-success f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["dns_time_avg"]["pie"][0]["per"]} <span>DNS 查询时间</span>
                  </li>
                  <li>
                    <i className="fa fa-circle fa-fw text-primary f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["dns_time_avg"]["pie"][1]["per"]} <span>其他时间</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* 服务器连接时间 */}
          <div className="col-lg-12">
            <div className="widget-chart with-sidebar inverse-mode">
              <div className="widget-chart-content bg-black">
                <h4 className="chart-title">
                  服务器连接时间
                  <small></small>
                </h4>
                <div className="widget-chart-full-width nvd3-inverse-mode">
                  <NVD3Chart
                    type="stackedAreaChart"
                    datum={this.state["tcp_time_avg"]["line"]}
                    height={260}
                    options={this.areaChartOptions}
                  />
                </div>
              </div>
              <div className="widget-chart-sidebar bg-black-darker">
                <div className="chart-number">
                  百分比
                  <small></small>
                </div>
                <div className="nvd3-inverse-mode" style={{ height: "180px" }}>
                  <NVD3Chart
                    type="pieChart"
                    datum={this.state["tcp_time_avg"]["pie"]}
                    height={180}
                    options={this.donutChartOptions}
                    x="label"
                    y="value"
                  />
                </div>
                <ul className="chart-legend f-s-11">
                  <li>
                    <i className="fa fa-circle fa-fw text-success f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["tcp_time_avg"]["pie"][0]["per"]} <span>服务器连接时间</span>
                  </li>
                  <li>
                    <i className="fa fa-circle fa-fw text-primary f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["tcp_time_avg"]["pie"][1]["per"]} <span>其他时间</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* 服务器响应时间 */}
          <div className="col-lg-12">
            <div className="widget-chart with-sidebar inverse-mode">
              <div className="widget-chart-content bg-black">
                <h4 className="chart-title">
                  服务器响应时间
                  <small></small>
                </h4>
                <div className="widget-chart-full-width nvd3-inverse-mode">
                  <NVD3Chart
                    type="stackedAreaChart"
                    datum={this.state["response_time_avg"]["line"]}
                    height={260}
                    options={this.areaChartOptions}
                  />
                </div>
              </div>
              <div className="widget-chart-sidebar bg-black-darker">
                <div className="chart-number">
                  百分比
                  <small></small>
                </div>
                <div className="nvd3-inverse-mode" style={{ height: "180px" }}>
                  <NVD3Chart
                    type="pieChart"
                    datum={this.state["response_time_avg"]["pie"]}
                    height={180}
                    options={this.donutChartOptions}
                    x="label"
                    y="value"
                  />
                </div>
                <ul className="chart-legend f-s-11">
                  <li>
                    <i className="fa fa-circle fa-fw text-success f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["response_time_avg"]["pie"][0]["per"]} <span>服务器响应时间</span>
                  </li>
                  <li>
                    <i className="fa fa-circle fa-fw text-primary f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["response_time_avg"]["pie"][1]["per"]} <span>其他时间</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* 白屏时间 */}
          <div className="col-lg-12">
            <div className="widget-chart with-sidebar inverse-mode">
              <div className="widget-chart-content bg-black">
                <h4 className="chart-title">
                  白屏时间
                  <small></small>
                </h4>
                <div className="widget-chart-full-width nvd3-inverse-mode">
                  <NVD3Chart
                    type="stackedAreaChart"
                    datum={this.state["white_time_avg"]["line"]}
                    height={260}
                    options={this.areaChartOptions}
                  />
                </div>
              </div>
              <div className="widget-chart-sidebar bg-black-darker">
                <div className="chart-number">
                  百分比
                  <small></small>
                </div>
                <div className="nvd3-inverse-mode" style={{ height: "180px" }}>
                  <NVD3Chart
                    type="pieChart"
                    datum={this.state["white_time_avg"]["pie"]}
                    height={180}
                    options={this.donutChartOptions}
                    x="label"
                    y="value"
                  />
                </div>
                <ul className="chart-legend f-s-11">
                  <li>
                    <i className="fa fa-circle fa-fw text-success f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["white_time_avg"]["pie"][0]["per"]} <span>白屏时间</span>
                  </li>
                  <li>
                    <i className="fa fa-circle fa-fw text-primary f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["white_time_avg"]["pie"][1]["per"]} <span>其他时间</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* DomReady 总时间 */}
          <div className="col-lg-12">
            <div className="widget-chart with-sidebar inverse-mode">
              <div className="widget-chart-content bg-black">
                <h4 className="chart-title">
                  DomReady 总时间
                  <small></small>
                </h4>
                <div className="widget-chart-full-width nvd3-inverse-mode">
                  <NVD3Chart
                    type="stackedAreaChart"
                    datum={this.state["domready_time_avg"]["line"]}
                    height={260}
                    options={this.areaChartOptions}
                  />
                </div>
              </div>
              <div className="widget-chart-sidebar bg-black-darker">
                <div className="chart-number">
                  百分比
                  <small></small>
                </div>
                <div className="nvd3-inverse-mode" style={{ height: "180px" }}>
                  <NVD3Chart
                    type="pieChart"
                    datum={this.state["domready_time_avg"]["pie"]}
                    height={180}
                    options={this.donutChartOptions}
                    x="label"
                    y="value"
                  />
                </div>
                <ul className="chart-legend f-s-11">
                  <li>
                    <i className="fa fa-circle fa-fw text-success f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["domready_time_avg"]["pie"][0]["per"]} <span>DomReady 总时间</span>
                  </li>
                  <li>
                    <i className="fa fa-circle fa-fw text-primary f-s-9 m-r-5 t-minus-1"></i>{" "}
                    {this.state["domready_time_avg"]["pie"][1]["per"]} <span>其他时间</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Modal
          visible={this.state.formConfsShow}
          title="项目配置"
          okText="确认"
          cancelText="取消"
          onCancel={this.cancelSubmitFormConfs}
          onOk={this.submitFormConfs}
        >
          <Form
            labelCol={{
              span: 6,
            }}
            wrapperCol={{
              span: 12,
            }}
            layout="horizontal"
          >
            <Form.Item label="项目名称">
              <Input
                placeholder="必填"
                value={this.state.formConfs.project_name}
                onChange={this.changeFormConfs.bind(this, "project_name")}
              />
            </Form.Item>
            <Form.Item label="标识（topic）">
              <Input
                placeholder="必填 / 英文数字的组合"
                value={this.state.formConfs.topic}
                onChange={this.changeFormConfs.bind(this, "topic")}
              />
            </Form.Item>
            <Form.Item label="项目描述">
              <Input
                placeholder="选填"
                value={this.state.formConfs.project_description}
                onChange={this.changeFormConfs.bind(this, "project_description")}
              />
            </Form.Item>
            <Form.Item label="负责人">
              <Input
                placeholder="选填"
                value={this.state.formConfs.owner}
                onChange={this.changeFormConfs.bind(this, "owner")}
              />
            </Form.Item>
            <Form.Item label="部门">
              <Input
                placeholder="选填"
                value={this.state.formConfs.department}
                onChange={this.changeFormConfs.bind(this, "department")}
              />
            </Form.Item>
            <Form.Item label="联系人">
              <Input
                placeholder="选填"
                value={this.state.formConfs.contact}
                onChange={this.changeFormConfs.bind(this, "contact")}
              />
            </Form.Item>
          </Form>
        </Modal>
      </Login>
    );
  }
}

export default DashboardV2;
